<template>
  <v-app>
    <v-main v-if="getSsoProcess()">
      <v-container :fluid="true" class="sso-container">
        <v-card
          class="sso-card"
          color="var(--color-brand-200)"
          height="30vh"
          flat
        >
          <v-card-title class="ssoProcess">
            {{ $t('gui.ssoprocess') }}
          </v-card-title>
          <v-img
            src="/svgs/proclus.svg"
            :alt="$t('alt.proclus')"
            height="20vh"
          />
        </v-card>
        <router-view />
      </v-container>
    </v-main>
    <v-main v-else-if="!getLoggedIn()" class="content">
      <router-view />
    </v-main>
    <template v-else>
      <NavigationSystem class="navigationtop" location="top" />
      <v-main class="content">
        <router-view />
      </v-main>
      <FooterMenu />
      <!--
      <NotifyUser
        v-show="hasNotification"
        @notificationseen="notificationDone"
      />
      -->
    </template>
    <BeatLoader
      class="spinnerloader"
      :loading="getLogInProcess()"
      color="var(--color-brand)"
      size="10rem"
    />
    <v-dialog v-model="showRefreshApp" max-width="55%">
      <v-card>
        <h2 style="margin: auto; padding: 0 2vw 0 2vw">
          {{ $t('gui.updateheading') }}
        </h2>
        <v-card-actions>
          <v-spacer />
          <v-btn
            :aria-label="$t('gui.close')"
            icon="mdi-close"
            @click="dismissAppUpdate"
          />
          <v-btn
            :aria-label="$t('gui.updateheading')"
            icon="mdi-refresh"
            @click="refreshApp"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'pinia'
import { adminStore } from '@/stores/adminstore.js'
import dayjs from '@/plugins/dayjs'
// import { inject } from "vue";

import networkStatusMixin from '@/mixins/networkStatusMixin.js'
import pwaUpdateMixin from '@/mixins/pwaUpdateMixin.js'
import FooterMenu from '@/components/menues/FooterMenu.vue'
import NavigationSystem from '@/components/menues/NavigationSystem.vue'
// import NotifyUser from '@/components/notify/NotifyUser.vue'
import { BeatLoader } from 'vue3-spinner'

import app from '@/../package.json'
// import { defineAsyncComponent } from 'vue'

const REGISTRY_URL_PROD = import.meta.env.VITE_REGISTRY_URL_PROD
const REGISTRY_URL_STAGE = import.meta.env.VITE_REGISTRY_URL_STAGE
const REGISTRY_URL_LOCAL = import.meta.env.VITE_REGISTRY_URL_LOCAL

export default {
  name: 'App',
  components: {
    FooterMenu,
    NavigationSystem,
    BeatLoader
    /*
    TodaysActiveAssignments: defineAsyncComponent(
      () => import('@/views/TodaysActiveAssignments.vue')
    )

    NotifyUser: defineAsyncComponent(
      () => import('@/components/notify/NotifyUser.vue')
    )
      */
  },
  mixins: [networkStatusMixin, pwaUpdateMixin],
  // inject: ['update'],
  beforeRouteEnter(to, from, next) {
    console.error('------- APP VUE BEFORE ENTER -------- ')
    console.log('to: (%o) from: (%o) next: (%o)', to, from, next)
  },
  data() {
    return {
      incrementSeconds: 0,
      hasNotification: true
    }
  },
  head() {
    return {
      title: this.$t('head.title'),
      meta: [
        { name: 'description', content: () => this.$t('head.description') },
        { name: 'keywords', content: () => this.$t('head.keywords') }
      ],
      htmlAttrs: [{ lang: this.$i18n.locale }]
    }
  },

  beforeMount() {
    console.info(
      '%c(c) Hypatia Learning AS\n%cVersion: %s\n%cLanguage: %s',
      'background: rgba(12, 77, 161, 0.8); color: hsl(0, 0%, 100%); font-size:1.2rem; font-weight:800;',
      'background: rgba(12, 77, 161, 0.2); color: rgba(0,155,155,0.8); font-weight:800;',
      app.version,
      'background: rgba(12, 77, 161, 0.2); color: rgba(0,155,155,0.8);',
      this.$i18n.locale
    )
    this.setDomain(location.hostname)
    console.log('APP BEFORE MOUNT <<<<<<<<<<<<<')
    let serverUrlInfo = localStorage.getItem('hypsaserver') || ''
    let registryUrlInfo = localStorage.getItem('hypregistry') || ''
    console.info(
      '==== A P P  serverUrl: (' +
        serverUrlInfo +
        ') registryUrl(' +
        registryUrlInfo +
        ')'
    )
    if (registryUrlInfo === '' || serverUrlInfo === '') {
      console.info(
        '*** MISSING SOME ESENNTIAL REGISTRY INFORMATION (%s) ***',
        location.hostname
      )
      // @todo fix set to nothing...
      // localStorage.setItem('hypregistry', 'https://www.hypatia.no')
      if (
        location.hostname === 'laerer.v4l.no' ||
        location.hostname === 'laerer.proclus.no' ||
        location.hostname === 'educator.proclus.eu'
      ) {
        this.setEnvironment('prod')
        if (REGISTRY_URL_PROD) {
          this.loadRegistry(REGISTRY_URL_PROD)
        } else {
          console.error('REGISTRY_URL_PROD is not set in environment.')
        }
      } else if (
        location.hostname === 'stage-laerer.v4l.no' ||
        location.hostname === 'stage-laerer.proclus.no' ||
        location.hostname === 'stage-educator.proclus.eu'
      ) {
        this.setEnvironment('stage')
        if (REGISTRY_URL_STAGE) {
          this.loadRegistry(REGISTRY_URL_STAGE)
        } else {
          console.error('REGISTRY_URL_STAGE is not set in environment.')
        }
      } else if (
        location.hostname === 'v4leducator.localhost' ||
        location.hostname === 'localhost'
      ) {
        this.setEnvironment('dev')
        if (REGISTRY_URL_LOCAL) {
          this.loadRegistry(REGISTRY_URL_LOCAL)
        } else {
          console.error('REGISTRY_URL_LOCAL is not set in environment.')
        }
      }
    } else {
      this.setServerUrl(serverUrlInfo)
      this.setRegistryUrl(registryUrlInfo)
      this.getPingServer()
        .then((result) => {
          console.log(
            'RESULT FOR APP - We have working connection with server !! '
          )
          console.log(result)
        })
        .catch((error) => {
          console.info(
            '*** ERROR *** could not get contact with PING server! ' + error
          )
          if (
            location.hostname === 'laerer.v4l.no' ||
            location.hostname === 'laerer.proclus.no' ||
            location.hostname === 'educator.proclus.eu'
          ) {
            this.setEnvironment('prod')
            if (REGISTRY_URL_PROD) {
              this.loadRegistry(REGISTRY_URL_PROD)
            } else {
              console.error('REGISTRY_URL_PROD is not set in environment.')
            }
          } else if (
            location.hostname === 'stage-laerer.v4l.no' ||
            location.hostname === 'stage-laerer.proclus.no' ||
            location.hostname === 'stage-educator.proclus.eu'
          ) {
            this.setEnvironment('stage')
            if (REGISTRY_URL_STAGE) {
              this.loadRegistry(REGISTRY_URL_STAGE)
            } else {
              console.error('REGISTRY_URL_STAGE is not set in environment.')
            }
          } else if (
            location.hostname === 'v4leducator.localhost' ||
            location.hostname === 'localhost'
          ) {
            this.setEnvironment('dev')
            if (REGISTRY_URL_LOCAL) {
              this.loadRegistry(REGISTRY_URL_LOCAL)
            } else {
              console.error('REGISTRY_URL_LOCAL is not set in environment.')
            }
          }
          /* Not during a running login: the login view shows its own error with retry, and sending the user
             to MustLogin here threw that away */
          if (!['Callback', 'FeideLoggedIn'].includes(this.$route.name)) {
            this.$router.push({ name: 'MustLogin' }).catch((e) => {
              console.error('COULD NOT ROUTE to mustlogin (%j)', e)
            })
          }
        })
    }
  },
  mounted() {
    console.log('++++++++++ APP is mounted ++++++++')
    let toFromDate = this.getToFromDate()
    console.log('toFromDate: (%j)', toFromDate)
    let startDate = dayjs().subtract(1, 'month')
    let endDate = startDate.add(2, 'month')
    let toFromPayload = {
      fromDate: startDate.format('YYYY-MM-DDT00:00:00'),
      toDate: endDate.format('YYYY-MM-DDT23:59:59')
    }
    this.setToFromDate(toFromPayload)

    /*
        let datePayload = {
            toDate: this.$date().add(1, 'day').format('YYYY-MM-DD'),
            fromDate: this.$date()
                .subtract(2, 'month')
                .subtract(1, 'day')
                .format('YYYY-MM-DD')
        }
        // this.setSearchDate(datePayload); // SHOULD BE LOADED FROM STORES
        */
  },
  methods: {
    ...mapActions(adminStore, [
      'addRegistryUrl',
      'setServerUrl',
      'setRegistryUrl',
      'getPingServer',
      'setToFromDate',
      'setDomain',
      'setEnvironment'
    ]),
    ...mapGetters(adminStore, [
      'getLoggedIn',
      'getLogInProcess',
      'getSsoProcess',
      'getToFromDate',
      'getDomain'
    ]),
    /* The registry lookup is not awaited here - but its rejection must be handled (it used to be an
       unhandled rejection, leaving the app without a server URL). MustLogin waits for the server URL. */
    loadRegistry(registryUrl) {
      this.addRegistryUrl(registryUrl).catch((error) => {
        console.error(
          '*** ERROR *** could not resolve the server URL from the registry',
          error
        )
      })
    },
    notificationDone() {
      console.log('GOT Notification DONE ')
      this.hasNotification = false
    }
  }
}
</script>

<style lang="css" scoped>
.spinnerloader {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}

.sso-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100%;
}

.sso-card {
  width: min(80vw, 72rem);
  max-width: 100%;
}

.ssoProcess {
  margin-left: auto;
  margin-right: auto;
  font-size: clamp(2rem, 4vw, 3.125rem);
  font-weight: 600;
}
</style>
